var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kstmod-rtninvoice-relatedlist"},[(_vm.action)?[(_vm.access.Act_New)?[_c('Action',{attrs:{"invoiceId":_vm.invoiceId}})]:_vm._e()]:_vm._e(),_c('Rows',{attrs:{"access":_vm.access,"dataList":_vm.dataList}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }